import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
// import home from '@/components/newHome'


import layout from '@/components/layout'
import profile from '@/components/profile'
import gProfile from '@/components/gProfile'

import clone from '@/components/clone'
import consum from '@/components/consum'
import create from '@/components/create'
import voice from '@/components/voice'
import works from '@/components/works'
import login from '@/components/login'
import moreCredits from '@/components/moreCredits'
import use from '@/components/use'
import multiples from '@/components/multiples'
import pet from '@/components/pet'
import establishPet from '@/components/establishPet'
import store from '@/components/store'
import extraction from '@/components/extraction'
import audioExtraction from '@/components/audioExtraction'
import sea from '@/components/sea'
import imageSpeak from '@/components/imageSpeak'
import characters from '@/components/characters'
import wsImage from '@/components/wsImage'
import wsVideo from '@/components/wsVideo'
import tsVideo from '@/components/tsVideo'
import aiChat from '@/components/aiChat'


Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   redirect: '/home'
    // },
    {
      path: '/',
      component: layout,
      redirect: '/home',
      meta: {
        title: '首页',
        keepAlive: false
      },
      children: [
        {
          path: '/home',
          name: 'Home',
          component: home,
          meta: {title: '首页', keepAlive: false}
        },
        {
          path: '/create',
          name: 'create',
          component: create,
          meta: {title: '开始创作', keepAlive: false}
        },
        {
          path: '/profile',
          name: 'profile',
          component: profile,
          meta: {title: '我的分身', keepAlive: false}
        },
        {
          path: '/gProfile',
          name: 'gProfile',
          component: gProfile,
          meta: {title: '公共形象', keepAlive: false}
        },
        {
          path: '/clone',
          name: 'clone',
          component: clone,
          meta: {title: '人声克隆', keepAlive: false}
        }, {
          path: '/multiples',
          name: 'multiples',
          component: multiples,
          meta: {title: '多场景克隆', keepAlive: false}
        }, {
          path: '/pet',
          name: 'pet',
          component: pet,
          meta: {title: '宠物视频', keepAlive: false}
        }, {
          path: '/pet/establish',
          name: 'establishPet',
          component: establishPet,
          meta: {title: '宠物视频创作', keepAlive: false}
        },
        {
          path: '/voice',
          name: 'voice',
          component: voice,
          meta: {title: '声音', keepAlive: false}
        },
        {
          path: '/works',
          name: 'works',
          component: works,
          meta: {title: '我的作品', keepAlive: false}
        }, {
          path: '/material/index',
          name: 'material',
          component: () => import('../components/material/index'),
          meta: {title: '我的素材', keepAlive: false}
        },
        {
          path: '/consum',
          name: 'consum',
          component: consum,
          meta: {title: '消费中心', keepAlive: false}
        }, {
          path: '/use',
          name: 'use',
          component: use,
          meta: {title: '使用指南', keepAlive: false}
        }, {
          path: '/store',
          name: 'store',
          component: store,
          meta: {title: '应用商店', keepAlive: false}
        },
        {
          path: '/moreCredits',
          name: 'moreCredits',
          component: moreCredits,
          meta: {title: '积分明细', keepAlive: false}
        },
        {
          path: '/store/extraction',
          name: 'extraction',
          component: extraction,
          meta: {title: '视频提取', keepAlive: false}
        }, {
          path: '/store/audioExtraction',
          name: 'audioExtraction',
          component: audioExtraction,
          meta: {title: '音频提取', keepAlive: false}
        },
        {
          path: '/store/sea',
          name: 'sea',
          component: sea,
          meta: {title: '出海视频', keepAlive: false}
        },
        {
          path: '/store/imageSpeak',
          name: 'imageSpeak',
          component: imageSpeak,
          meta: {title: '照片说话', keepAlive: false}
        }, {
          path: '/store/characters',
          name: 'characters',
          component: characters,
          meta: {title: '创建图片说话', keepAlive: false}
        }, {
          path: '/store/wsImage',
          name: 'wsImage',
          component: wsImage,
          meta: {title: '文生图', keepAlive: false}
        }, {
          path: '/store/wsVideo',
          name: 'wsVideo',
          component: wsVideo,
          meta: {title: '文生视频', keepAlive: false}
        }, {
          path: '/store/tsVideo',
          name: 'tsVideo',
          component: tsVideo,
          meta: {title: '图生视频', keepAlive: false}
        }, {
          path: '/store/aiChat',
          name: 'aiChat',
          component: aiChat,
          meta: {title: '文案花火', keepAlive: false}
        }, {
          path: '/explosiveAnalysis',
          name: 'explosiveAnalysis',
          component: () => import('../components/explosive/explosiveAnalysis'),
          meta: {title: '超级复刻', keepAlive: false}
        }, {
          path: '/explosiveAnalysis/video',
          name: 'explosiveVideo',
          component: () => import('../components/explosive/explosiveVideo'),
          meta: {title: '视频解析', keepAlive: false}
        }, {
          path: '/explosiveAnalysis/user',
          name: 'explosiveUser',
          component: () => import('../components/explosive/userAnalysis'),
          meta: {title: '账号解析', keepAlive: false}
        }, {
          path: '/explosiveAnalysis/character',
          name: 'explosiveCharacter',
          component: () => import('../components/explosive/character'),
          meta: {title: '我的人设', keepAlive: false}
        }, {
          path: '/explosiveAnalysis/project',
          name: 'explosiveProject',
          component: () => import('../components/explosive/project'),
          meta: {title: '我的产品', keepAlive: false}
        }, {
          path: '/employee',
          name: 'employee',
          component: () => import('../components/employee/index'),
          meta: {title: 'AI超级员工', keepAlive: false}
        }, {
          path: '/employee/talking',
          name: 'talking',
          component: () => import('../components/employee/talking'),
          meta: {title: '员工对话', keepAlive: false}
        },


        {
          path: '/helper/index',
          name: 'helperIndex',
          component: () => import('../components/helper/index'),
          meta: {title: '超级助手', keepAlive: false}
        },
        {
          path: '/helper/operation',
          name: 'operation',
          component: () => import('../components/helper/operation'),
          meta: {title: '超级助手', keepAlive: false}
        },
        {
          path: '/helper/asyncOperation',
          name: 'asyncOperation',
          component: () => import('../components/helper/asyncOperation'),
          meta: {title: '超级助手', keepAlive: false}
        },
        {
          path: '/copywrite/index',
          name: 'copywriteIndex',
          component: () => import('../components/copywrite/index'),
          meta: {title: '专属文案', keepAlive: false}
        },
        {
          path: 'store/copywrite/trace',
          name: 'trace',
          component: () => import('../components/copywrite/trace'),
          meta: {title: '提取文案', keepAlive: false}
        },
        {
          path: 'store/music/index',
          name: 'trace',
          component: () => import('../components/music/index'),
          meta: {title: 'AI音乐', keepAlive: false}
        },{
          path: '/cozeVideo',
          name: 'cozeVideo',
          component: () => import('../components/cozeVideo/index'),
          meta: {title: '一键创作', keepAlive: false}
        },{
          path: '/cozeVideo/editVideo',
          name: 'editVideo',
          component: () => import('../components/cozeVideo/editVideo'),
          meta: {title: '视频创作', keepAlive: false}
        },{
          path: '/cozeVideo/history',
          name: 'history',
          component: () => import('../components/cozeVideo/cozeHistory'),
          meta: {title: '视频历史记录', keepAlive: false}
        },
        {
          path: '/store/dubbing/index',
          name: 'dubbing',
          component: () => import('../components/dubbing/index'),
          meta: {title: '配音', keepAlive: false}
        }



      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {title: '登录', keepAlive: false}
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: () => import('../components/protocol.vue'),
      meta: {title: '协议', keepAlive: false}
    },
  ],
  mode: 'hash',
})



// WEBPACK FOOTER //
// ./src/router/index.js